import { StyleSheet } from 'aphrodite';
import { error, titles } from '../../styles/colors';

// tslint:disable:object-literal-key-quotes

export const styleSheet = StyleSheet.create({
	container: {
		color: titles,
		marginBottom: 20,
		marginTop: 20,
	},
	input: {
		border: '1px solid #CCC',
		borderRadius: 3,
		boxSizing: 'border-box',
		fontSize: 16,
		height: 40,
		marginTop: 5,
		padding: '5px 10px',
		width: '100%',
	},
	required: {
		color: error,
		fontSize: 14,
		paddingLeft: 5,
	},
});
